export const FullModal = (function () {
	'use strict';

	let $fullModal, $closeFullModal;

	function init() {
		$fullModal = $('[data-full-modal]');
		$closeFullModal = $('[data-close-full-modal]');
		if($fullModal) {
			events();
		}
		if($closeFullModal) {
			closeFullModals($closeFullModal);
		}
	}

	function events() {
		$fullModal.each(function(e){
			// e.preventDefault();
			let $modalBtn, $modalId, $modal;
			$modalBtn = $(this);
			$modalId = $modalBtn.data('full-modal');
			$modal = $('#' + $modalId);
			
			$modalBtn.on('click', function(){
				$modal.addClass('active');
			});
			
		});
	}

	function closeFullModals(close) {
		$(close).on('click', function(){
			$('.modals').removeClass('active');
		});
	}

	return {
		init: init,
	};
})();
